// eslint-disable-next-line no-unused-vars
import { ICreateUser } from '../../../../../../TypeScript/Interfaces/ICreateUser';

export default {
  Email: '',
  ConfirmEmail: '',
  Password: '',
} as ICreateUser;
